export const YES = 'yes';
export const NO = 'no';

export const APP_CONFIRMATION_DIALOG_RESPONSES = Object.freeze({
	YES,
	NO,
});
